import { render, staticRenderFns } from "./PetPage.vue?vue&type=template&id=6f977815&scoped=true"
import script from "./PetPage.vue?vue&type=script&lang=js"
export * from "./PetPage.vue?vue&type=script&lang=js"
import style0 from "./PetPage.vue?vue&type=style&index=0&id=6f977815&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f977815",
  null
  
)

export default component.exports